import React from 'react'
import {Card} from 'antd'

class MainContentSright extends React.Component {
    constructor(props){
        super(props)
    }
    state={}
    componentDidMount(){}
    render(){
        return(
            <div>
                <Card 
                    style={{minHeight: '30vh'}}
                    className=''
                    bordered={true}
                >

                    <p>submit box</p>
                </Card>
                <Card 
                    className=''
                    bordered={true}
                >

                    <p>Upcoming box</p>
                </Card>
            </div>
        )
    }
}

export default MainContentSright;